<div class="p-fluid p-formgrid grid mt-2">
    <div class="field col-12 md:col-10">
        @for (tramitesPrevios of this.tramitesPrevios; track $index) {
            <div class="field col-12 mb-4">
                <div class="flex flex-column md:flex-row justify-content-between align-items-center">
                    <div class="flex align-items-center mb-2 md:mb-0">
                        <label class="text-900 font-semibold mr-2">{{ tramitesPrevios.nombre }}</label>
                        <p class="text-900 font-semibold mr-2">Exp.</p>
                    </div>
                    <input type="text" placeholder="Solicitud #"
                           value="" [(ngModel)]="expediente" id="expediente"
                           #expedienteInput required pInputText
                           class="surface-100 text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full md:mr-3">
                    <p-fileUpload [maxFileSize]="this.fileUtilsService.maxFileSize" [auto]="true" customUpload="true"
                                  #cargaArchivos id="cargaArchivos" mode="basic"
                                  chooseLabel="Cargar archivo"
                                  (uploadHandler)="onFileUpload($event,cargaArchivos)"
                                  name="demo[]" accept="{{this.fileUtilsService.formatoArchivo}}" class="w-full"
                                  invalidFileTypeMessageDetail="Adjuntar un archivo con un formato compatible {{this.fileUtilsService.formatoArchivo}}"
                                  invalidFileTypeMessageSummary="Formato inválido"
                                  invalidFileSizeMessageSummary="Archivo demasiado grande"
                                  invalidFileSizeMessageDetail="El archivo supera el tamaño máximo permitido de {{ this.fileUtilsService.maxFileSize / 250000000 }} MB"
                    ></p-fileUpload>
                </div>
            </div>
        }
    </div>
</div>

